import supabase from './supabase';

// falta error handling
const uploadComprobantePago = async (id, comprobante, operacionId) => {
  if (!comprobante) return;

  const { data, error } = await supabase.storage
    .from('usuarios')
    .upload(`${id}/comprobantes/${operacionId}`, comprobante, {
      cacheControl: '3600',
      upsert: true,
    });

  if (data) {
    //console.log('DATA', data);
    return data;
  } else {
    console.log(error);
    return null;
  }
};

export default uploadComprobantePago;
